import React, { useEffect, useRef, useState } from "react";
import step1 from "../assets/images/Steps/set up meal plan screen.png";
import step2 from "../assets/images/Steps/order delivery proof.png";
import step3 from "../assets/images/Steps/Payment - Balance.png";
import PrimaryBtn from "./Button/PrimaryBtn";

const Features = () => {
  const features = [
    {
      image: step1,
      title: "Order & Subscription Management",
      points: [
        "Add day wise meal plans",
        "Set one-time, weekly & monthly costing options",
        "Define number of servings per subscription",
        "Auto-create recurring orders",
        "Define delivery range & charges",
      ],
      // Soft warm gradient, subtle and premium
      bgColor: "bg-gradient-to-br from-orange-50 via-white to-orange-100",
    },
    {
      image: step2,
      title: "Customer & Delivery Management",
      points: [
        "Track customers details – orders & payments",
        "Create single or subscription orders",
        "Capture delivery proof (photo)",
        "Track order payment status",
        "Receive new customer inquiries",
      ],
      // Soft grayish-green gradient that blends with theme
      bgColor: "bg-gradient-to-r from-[#FFF4F1] via-[#E4ECE9] to-[#ff6943]/20",
    },
    {
      image: step3,
      title: "Payment & Balance Tracking",
      points: [
        "Record payments",
        "View order & payment history",
        "View balance sheet for each customer",
        "Share order history with customers",
      ],
      // Light grayish-blue, subtle premium feel
      bgColor: "bg-gradient-to-r from-[#F4F8FC] via-[#E2EBF5] to-[#C7D8EF]",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionRefs.current.indexOf(entry.target);
            setActiveIndex(index);
          }
        });
      },
      { threshold: 0.6 },
    );

    sectionRefs.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`py-16 transition-colors duration-700 ${
        features[activeIndex].bgColor
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* MOBILE LAYOUT */}
        <div className="block md:hidden space-y-20">
          {features.map((feature, index) => (
            <div key={index} className="space-y-6">
              <img
                src={feature.image}
                alt="App Screen"
                className="w-auto"
              />

              <h2 className="text-2xl lg:text-3xl xl:text-4xl font-bold">{feature.title}</h2>

              <ul className="space-y-3">
                {feature.points.map((point, i) => (
                  <li key={i} className="flex gap-3">
                    <span className="text-orange-500 font-bold">→</span>
                    <p className="text-gray-700 text-sm">{point}</p>
                  </li>
                ))}
              </ul>

              <PrimaryBtn btnName={"Get App for Free"} />
            </div>
          ))}
        </div>

        {/* DESKTOP LAYOUT */}
        <div className="hidden md:grid md:grid-cols-2 gap-16">
          {/* LEFT CONTENT */}
          <div className="space-y-40">
            {features.map((feature, index) => (
              <div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                className="min-h-[80vh] flex flex-col justify-center"
              >
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                  {feature.title}
                </h2>

                <ul className="space-y-4">
                  {feature.points.map((point, i) => (
                    <li key={i} className="flex gap-3">
                      <span className="text-orange-500 font-bold">→</span>
                      <p className="text-gray-700">{point}</p>
                    </li>
                  ))}
                </ul>

                <div className="mt-6">
                  <PrimaryBtn btnName={"Get App for Free"} />
                </div>
              </div>
            ))}
          </div>

          {/* STICKY IMAGE */}
          <div className="sticky top-32 h-[85vh] flex items-center justify-center relative">
            {features.map((feature, index) => (
              <img
                key={index}
                src={feature.image}
                alt="App Screen"
                className={`absolute w-[320px] drop-shadow-[0_50px_80px_rgba(0,0,0,0.4)]
                  transition-opacity duration-700
                  ${activeIndex === index ? "opacity-100" : "opacity-0"}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;